import installBlockQuote from './config';

export default installBlockQuote;
